
const myuserFullcont        = require('./myuser-fullcont')


export function start(detail){  //console.log('myuser-dt 5>', detail)
         
      obj[detail.elem].start(detail)

}/**/



const obj = {

      fullcont:           { start: (detail)=>{  myuserFullcont. start(detail)        }},

}







